export default __webpack_public_path__ + "static/footer-background-114e4d07018e897c1d42352d2201f2ba.webp";